import styled from "styled-components";


export const Container = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
    overflow: hidden;

    .card {
        display: flex;
        flex-direction: column;
        gap: 6px;
        width: 140px;
        height: 69px;
        border-radius: 8px;
        padding: 8px;

        .top {
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 24px;
            font-weight: 400;
        }

        span {
            font-size: 14px;
            font-weight: 600;
            color: ${({ theme }) => theme.colors.interfaceText400};
        }

        &.resolved {
            background-color: ${({ theme }) => theme.colors.interfaceSuccess100};
            .top {
                color: ${({ theme }) => theme.colors.interfaceSuccess400};
                svg {
                    width: 12px;
                    path {
                        fill: ${({ theme }) => theme.colors.interfaceSuccess400};
                    }
                }
            }
        }
        &.accept {
            background-color: ${({ theme }) => theme.colors.secondaryGreen050};
            .top {
                color: ${({ theme }) => theme.colors.secondaryGreen600};
                svg {
                    width: 12px;
                    path {
                        fill: ${({ theme }) => theme.colors.secondaryGreen600};
                    }
                }
            }
        }
        &.refused {
            background-color: ${({ theme }) => theme.colors.interfaceDanger100};
            .top {
                color: ${({ theme }) => theme.colors.interfaceDanger400};
                svg {
                    path {
                        fill: ${({ theme }) => theme.colors.interfaceDanger400};
                    }
                }
            }
        }
        &.waiting {
            background-color: ${({ theme }) => theme.colors.primaryOrange50};
            .top {
                color: ${({ theme }) => theme.colors.primaryOrange700};
                svg {
                    width: 12px;
                    path {
                        fill: ${({ theme }) => theme.colors.primaryOrange700};
                    }
                }
            }
        }
        &.response {
            background-color: ${({ theme }) => theme.colors.secondaryPool100};
            .top {
                color: ${({ theme }) => theme.colors.primaryBlue100};
                svg {
                    path {
                        fill: ${({ theme }) => theme.colors.primaryBlue100};
                    }
                }
            }

            span {
                color: ${({ theme }) => theme.colors.interfaceText400};
            }
        }
    }
    
    .arrow {
        cursor: pointer;
        width: 48px;
        svg {
            path {
                fill: ${({ theme }) => theme.colors.interfaceTextGray};
            }
        }
    }

    @media (max-width: 480px) {
        gap: 8px;
        .card { width: calc(50% - 8px); min-width: 140px; }
    }

    @media (min-width: 769px) {
        flex-wrap: nowrap;
    }
`